export class BussinessAppUserToken {
  static IBussinessAppUserRepository = Symbol("IBussinessAppUserRepository");
  static BussinessAppUserUseCase = Symbol("BussinessAppUserUseCase");
  static BusinessUserAppManagementViewModel = Symbol(
    "BusinessUserAppManagementViewModel",
  );
}
